$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
moment = require 'moment'

InviteAcceptanceNotification = require 'app/scripts/views/board/invite-acceptance-notification'
Auth = require 'app/scripts/db/auth'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
{ trackUe } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports.closeInviteAcceptanceNotification = ->
  @unmountInviteAcceptanceNotification()

module.exports.buildInviteAcceptanceNotification = (members) ->
  React.createElement InviteAcceptanceNotification,
    members: members
    onClose: @closeInviteAcceptanceNotification

# The newly signed up invitees we want to identify here are members who:
# - were invited by the current user
# - have completed sign up and joined the board
# - haven't already notified the current user that they signed up
module.exports.getNewlySignedUpInvitees = ->
  myId = Auth.me().id
  lastViewMoment = moment(@model.get('previousDateLastView'))
  membersHash = {}
  @model.memberList.models.forEach (member) =>
    membersHash[member.get('id')] = member

  @model.get('memberships').reduce (newlyInvitedMembers, membership) =>
    member = membersHash[membership.idMember]
    if member &&
       moment(Util.idToDate(member.id)).isAfter(lastViewMoment) &&
       member.get('idMemberReferrer') == myId &&
       member.get('memberType') == 'normal'
      return newlyInvitedMembers.concat(member)
    return newlyInvitedMembers
  , []

module.exports.renderPopovers = ->
  # Given that there was a race condition between the Teamless colaboration prompt
  # and the InviteAcceptanceNotification, we needed to control which one to shows first.
  # Now we are showing the InviteAcceptanceNotification first.
  visibleMembers = @model.orderedVisibleMembers()
  newInvitees = @getNewlySignedUpInvitees()
  isInviteDismissed = Auth.me().isDismissed('notify-invite-acceptance')
  canRenderInviteAcceptanceNotification = !isInviteDismissed && newInvitees.length != 0

  # We want to keep track if one of these popovers are currently open or not
  if @isPopoverRendered
    return @

  if canRenderInviteAcceptanceNotification
    # Show InviteAcceptanceNotification if:
    # - there are new invitees
    # - Invite Acceptance hasn't been dismissed
    # - @isPopoverRendered is false
    @renderInviteAcceptanceNotification(newInvitees, _.map visibleMembers, (member) -> member.id)
    newInvitees.forEach((member) ->
      trackUe(
        'board header',
        'sees',
        'new member signed up',
        '',
        '',
        'by invite acceptance notification', {
          referringMember: Auth.me().id,
          newMember: member.id
        }
      )
      Analytics.sendOperationalEvent
        action: 'rendered'
        actionSubject: 'inviteAcceptanceNotification'
        source: 'boardScreen'
        attributes:
          referringMember: Auth.me().id
          newMember: member.id
    )

  else
    # No InviteAcceptanceNotification.
    # Track these users as NOT having seen the invite notification
    newInvitees.forEach((member) ->
      trackUe(
        'board header',
        'doesnt see',
        'new member signed up',
        '',
        '',
        '', {
          referringMember: Auth.me().id,
          newMember: member.id
        }
      )
      Analytics.sendOperationalEvent
        action: 'skipped'
        actionSubject: 'inviteAcceptanceNotification'
        source: 'boardScreen'
        attributes:
          referringMember: Auth.me().id
          newMember: member.id
    )
    # Render the Teamless colaboration prompt if:
    # - there aren't new invitees
    # - if teamless hasn't been dismissed
    # - the invite aceptance notification isn't open
    # - the teamless collaboration prompt hasn't already been seen since the board initialized
    if !@teamlessCollaborationPromptHasBeenSeen
      @renderTeamlessCollaborationPrompt()

  @isPopoverRendered = true

module.exports.renderInviteAcceptanceNotification = (newInvitees, visibleMemberIds) ->
  # Find out where the notification should be displayed
  avatarPosition = '#member-count-notifications'
  if newInvitees.length == 1
    if newInvitees[0].id in visibleMemberIds
      possibleAvatarPosition = "#" + newInvitees[0].id + "-avatar"
      newInviteePosition = $(possibleAvatarPosition).offset()?
      # if the new members are not visible then
      # attach the notification to the counter
      if !newInviteePosition
        avatarPosition = possibleAvatarPosition

  # Tear down any existing notifications
  @unmountInviteAcceptanceNotification()

  # Create a new notification
  @inviteAcceptanceNotificationDiv = document.createElement('div')
  @$('#board-header-notification').append(@inviteAcceptanceNotificationDiv)
  @inviteAcceptanceNotificationComponent = ReactDOM.render(
    @buildInviteAcceptanceNotification(newInvitees),
    @inviteAcceptanceNotificationDiv
  )
  avatarObject = $(avatarPosition)
  $(".invite-acceptance-notification").css('left', avatarObject.offset().left - 16)

  @

module.exports.unmountInviteAcceptanceNotification = ->
  if @inviteAcceptanceNotificationDiv?
    ReactDOM.unmountComponentAtNode(@inviteAcceptanceNotificationDiv)
    @inviteAcceptanceNotificationDiv = null
    @inviteAcceptanceNotificationComponent = null
  # We want to make sure that we aren't displaying
  # the teamless collaboration popover at the same time
  @isPopoverRendered = false
